import React, { Component } from 'react';
import { compose } from 'recompose';
import Report from '../../components/report';


class CampaignReport extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { params } = this.props;
    return (
      <Report id={params.id} type="basic" />
    );
  }
}

export default CampaignReport;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-report/index.js
 **/